/**
 * @flow
 * @relayHash 252046217e927f8dff3fa0c7ac48f85f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type floorPlanQueryVariables = {|
  propertyId: string,
  type: string,
|};
export type floorPlanQueryResponse = {|
  +categories: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +type: string,
    +createdAt: any,
    +hasMore: boolean,
    +floorPlans: $ReadOnlyArray<{|
      +id: string,
      +name: string,
      +areaMin: ?string,
      +areaMax: ?string,
      +imageName: string,
      +imageUrl: string,
      +imageSize: number,
      +imageDimension: string,
      +thumbnailUrl: ?string,
      +createdAt: any,
    |}>,
  |}>
|};
export type floorPlanQuery = {|
  variables: floorPlanQueryVariables,
  response: floorPlanQueryResponse,
|};
*/


/*
query floorPlanQuery(
  $propertyId: ID!
  $type: String!
) {
  categories(propertyId: $propertyId, type: $type) {
    id
    name
    type
    createdAt
    hasMore
    floorPlans {
      id
      name
      areaMin
      areaMax
      imageName
      imageUrl
      imageSize
      imageDimension
      thumbnailUrl
      createdAt
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "propertyId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "type",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v4 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "categories",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "propertyId",
        "variableName": "propertyId"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "Category",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasMore",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "floorPlans",
        "storageKey": null,
        "args": null,
        "concreteType": "FloorPlan",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "areaMin",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "areaMax",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "imageName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "imageUrl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "imageSize",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "imageDimension",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "thumbnailUrl",
            "args": null,
            "storageKey": null
          },
          (v3/*: any*/)
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "floorPlanQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v4/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "floorPlanQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v4/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "floorPlanQuery",
    "id": null,
    "text": "query floorPlanQuery(\n  $propertyId: ID!\n  $type: String!\n) {\n  categories(propertyId: $propertyId, type: $type) {\n    id\n    name\n    type\n    createdAt\n    hasMore\n    floorPlans {\n      id\n      name\n      areaMin\n      areaMax\n      imageName\n      imageUrl\n      imageSize\n      imageDimension\n      thumbnailUrl\n      createdAt\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ab228e22ca215841fa15afebd2c27778';
module.exports = node;
